var o = {
  type: null,
  messageCode: null
}, a = (i) => ({
  showNotification: (t) => i({ notification: t }),
  clearNotification: () => i({ notification: o })
});
export {
  a as createNotificationActions,
  o as initialNotificationState
};

//# sourceMappingURL=notification.action.js.map